<template>
  <div v-if="!item.hidden">
    <template v-if="hasOneShowingChild(item.nodes,item) && (!onlyOneChild.nodes||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
      <app-link v-if="onlyOneChild" :to="resolvePath(onlyOneChild.url)">
        <el-menu-item :index="resolvePath(onlyOneChild.url)" :class="{'submenu-title-noDropdown':!isNest}">
          <item :icon="onlyOneChild.icon ? imageOss + onlyOneChild.icon : onlyOneChild.icon" :title="onlyOneChild.title" />
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.url)" popper-append-to-body>
      <template slot="title">
        <item v-if="item" :icon="item.icon ? imageOss + item.icon : item.icon" :title="item.title" />
      </template>
      <sidebar-item
        v-for="child in item.nodes"
        :key="child.path"
        :is-nest="true"
        :item="child"
        :base-path="resolvePath(child.url)"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
// import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'
import { mapGetters } from "vuex";
export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([ "imageOss"]),
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {
      imgUrl: this.$store.state.imageOss

    }
  },
  created() {
  },
  methods: {
    hasOneShowingChild(children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })
      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ... parent, path: '', noShowingChildren: true }
        return true
      }
      return false
    },
    resolvePath(routePath) {
      // if (isExternal(routePath)) {
      //   return routePath
      // }
      // if (isExternal(this.basePath)) {
      //   return this.basePath
      // }
      return path.resolve(this.basePath, routePath)
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-submenu__title {
  color: #fff !important;
}
::v-deep .el-submenu__title i{
  color: #fff !important;
  font-size: 8px;
  // margin-top: 0 !important;
}
.nest-menu .el-submenu > .el-submenu__title,
  .el-menu-item {
    color: #fff !important;
    &:hover {
      // you can use $subMenuHover
      background-color: rgba(4,122,255,.1) !important;
    }
  }
  .sidebar-container .is-active.el-menu-item{
    border-color: #047aff;
    background: #047aff!important;
  }
</style>
